export default __webpack_public_path__ + "static/media/steps__slider-main-item-icon-little-8.3e343fb9.svg";